(function () {
    'use strict';

    angular.module('app.paymentGateways', [
        'app.core',
        'app.widgets'
    ]);
})();
